import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/confirm_btn.webp'
import _imports_1 from '@/assets/imgs/confirm_btn.png'
import _imports_2 from '@/assets/imgs/cancel_btn.webp'
import _imports_3 from '@/assets/imgs/cancel_btn.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-1bc5d3a8")

_pushScopeId("data-v-1bc5d3a8")
const _hoisted_1 = _imports_0
const _hoisted_2 = _imports_2
const _hoisted_3 = { class: "m-bet-view-root" }
const _hoisted_4 = /*#__PURE__*/_createVNode("source", {
  type: "image/webp",
  srcset: _hoisted_1
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  "data-was-processed": "true",
  "data-src": "~@/assets/imgs/confirm_btn.png"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("source", {
  type: "image/webp",
  srcset: _hoisted_2
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  "data-was-processed": "true",
  "data-src": "~@/assets/imgs/cancel_btn.png"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_mobile_dragon_tiger_bet_view = _resolveComponent("mobile-dragon-tiger-bet-view")
  const _component_mobile_baccrat_bet_view = _resolveComponent("mobile-baccrat-bet-view")

  return (_openBlock(), _createBlock("div", _hoisted_3, [
    (_ctx.gameType !== 'G002')
      ? (_openBlock(), _createBlock(_component_mobile_dragon_tiger_bet_view, {
          key: 0,
          chipValue: _ctx.chipValue,
          allowBet: _ctx.allowBet,
          redConfirmed: _ctx.redConfirmed,
          blueConfrimed: _ctx.blueConfirmed,
          greenConfrimed: _ctx.greenConfirmed,
          s6Mode: _ctx.s6Mode,
          onOnBetChange: _ctx.onBetChange,
          onBetSuccess: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('bet-success'))),
          ref: "bettingview"
        }, null, 8, ["chipValue", "allowBet", "redConfirmed", "blueConfrimed", "greenConfrimed", "s6Mode", "onOnBetChange"]))
      : (_openBlock(), _createBlock(_component_mobile_baccrat_bet_view, {
          key: 1,
          chipValue: _ctx.chipValue,
          allowBet: _ctx.allowBet,
          redConfirmed: _ctx.redConfirmed,
          blueConfrimed: _ctx.blueConfirmed,
          greenConfrimed: _ctx.greenConfirmed,
          redPairConfirmed: _ctx.redPairConfirmed,
          bluePairConfirmed: _ctx.bluePairConfirmed,
          super6Confirmed: _ctx.super6Confirmed,
          redSuper6Confimed: _ctx.redSuper6Confimed,
          bearEightConfirmed: _ctx.bearEightConfirmed,
          dragonSevenConfirmed: _ctx.dragonSevenConfirmed,
          bigTigerConfirmed: _ctx.bigTigerConfirmed,
          smallTigerConfirmed: _ctx.smallTigerConfirmed,
          onOnBetChange: _ctx.onBetChange,
          onBetSuccess: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('bet-success'))),
          s6Mode: _ctx.s6Mode,
          ref: "bettingview",
          juNo: _ctx.juNo
        }, null, 8, ["chipValue", "allowBet", "redConfirmed", "blueConfrimed", "greenConfrimed", "redPairConfirmed", "bluePairConfirmed", "super6Confirmed", "redSuper6Confimed", "bearEightConfirmed", "dragonSevenConfirmed", "bigTigerConfirmed", "smallTigerConfirmed", "onOnBetChange", "s6Mode", "juNo"])),
    (_ctx.hasUnconfirmedBet)
      ? (_openBlock(), _createBlock("div", {
          key: 2,
          class: ["m-cancel_confirm", { 'off-set-me': _ctx.gameType !== 'G002' }]
        }, [
          _createVNode("picture", {
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.confirmBet()), ["stop"]))
          }, [
            _hoisted_4,
            _hoisted_5
          ]),
          _createVNode("picture", {
            onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cancelBet && _ctx.cancelBet(...args)), ["stop"]))
          }, [
            _hoisted_6,
            _hoisted_7
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
})